import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ErrorDisplay from "../../components/error/ErrorDisplay";
// import { DeployList } from '../deploy/DeployList'
// import { ResourceDeployList } from '../deploy/ResourceDeployList'

import { Box, Grid, useTheme } from "@mui/material";
import { getHeaders } from "../../utils/common";
import Loading from "../../Loading";
import StatusBar from "../../components/StatusBar";
import FileList from "../modals/FileList";

export type SessionView = {
  owner_id: string;
  session_name: string;
  organisation_name?: string;
  user_role: string;
};

type appParams = {
  sessionID: string;
};

export type SessionInfo = {
  name: string;
  public: boolean;
  schema_version: string;
  schema_date: string;
  has_custom_schema: string;
  view: SessionView;
};

/**
 * Session Page
 * all file list, deployment list and resource deployment list
 * @returns {JSX.Element}
 */
export default function Session(): JSX.Element {
  const { sessionID } = useParams<appParams>();
  const theme = useTheme();
  const linkType = localStorage.getItem("defaultFileView") || "graph";
  const [fetchError, setFetchError] = useState(null);

  const [isLoading, setLoading] = useState(true);
  const [session, setSession] = useState<SessionInfo | null>(null);

  const myHeaders = getHeaders();
  useEffect(() => {
    let subscribed = true;

    fetch(`/mqttapi/v1/session/${sessionID}`, {
      headers: myHeaders,
      method: "GET",
    })
      .then(async (response) => {
        if (response.ok) {
          setFetchError(null);
          return response.json();
        }
        const text = await response.text();
        throw new Error(`${response.statusText}: ${text}`);
      })
      .then((json) => {
        if (!subscribed) {
          return;
        }
        setSession(json);
      })
      .catch((error) => {
        setFetchError(error);
      })
      .finally(() => (subscribed ? setLoading(false) : null));

    return () => {
      subscribed = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionID]);

  return (
    <>
      {/* <StatusBar
        crumbs={{
          session: {
            id: sessionID || '',
            name: session?.name || '',
          },
          organisation: session?.view.organisation_name
            ? {
                id: session.view.owner_id,
                name: session.view.organisation_name,
              }
            : undefined,
        }}
      ></StatusBar> */}
      <Box sx={{ padding: theme.spacing(2) }}>
        {isLoading ? (
          <Loading />
        ) : fetchError !== null ? (
          <ErrorDisplay
            err={fetchError}
            url={`/mqttapi/v1/session/${sessionID}`}
          />
        ) : (
          <FileList
            selectedFile=""
            defaultConfigType={linkType}
            sessionID={sessionID || ""}
          />
        )}
      </Box>
    </>
  );
}
